export default [
  {
    path: '/goods-manage',
    name: 'goods-manage',
    component: resolve => require(['views/goods-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/goods-manage/goods-form/:isEdit/:id',
    name: 'goods-form',
    props: true,
    component: resolve => require(['views/goods-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '商品管理/商品', isForm: true }
  },
  {
    path: '/goods-review',
    name: 'goods-review',
    component: resolve => require(['views/goods-review'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/goods-group',
    name: 'goods-group',
    component: resolve => require(['views/goods-group'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/goods-group/group-form/:isEdit/:id',
    name: 'group-form',
    props: true,
    component: resolve => require(['views/group-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '商品分组/商品分组', isForm: true }
  },
  {
    path: '/promotion-coupon',
    name: 'promotion-coupon',
    component: resolve => require(['views/promotion-coupon'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/promotion-coupon/coupon-form/:isEdit/:id',
    props: true,
    name: 'coupon-form',
    component: resolve => require(['views/coupon-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '促销管理/优惠劵', isForm: true }
  },
  {
    path: '/coupon-review',
    name: 'coupon-review',
    component: resolve => require(['views/coupon-review'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/coupon-review/coupon-detail/:id',
    name: 'coupon-detail',
    props: true,
    component: resolve => require(['views/coupon-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '优惠券审核/优惠劵详情' }
  },
  {
    path: '/promotion-coupon/coupon-detail/:id',
    name: 'coupon-detail',
    props: true,
    component: resolve => require(['views/coupon-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '促销管理/优惠劵详情' }
  },
  {
    path: '/promotion-coupon/promotion-form/:isEdit/:id',
    props: true,
    name: 'promotion-form',
    component: resolve => require(['views/promotion-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '促销管理/促销活动', isForm: true }
  },
  {
    path: '/promotion-coupon/promotion-form/:isEdit/:id/:isActive',
    props: true,
    name: 'promotion-form',
    component: resolve => require(['views/promotion-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '促销管理/促销活动', isForm: true }
  },
  {
    path: '/promotion-review',
    name: 'promotion-review',
    component: resolve => require(['views/promotion-review'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/promotion-review/propmotion-detail/:id',
    name: 'propmotion-detail',
    props: true,
    component: resolve => require(['views/propmotion-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '促销活动审核/促销活动详情' }
  },
  {
    path: '/promotion-coupon/propmotion-detail/:id',
    name: 'propmotion-detail',
    props: true,
    component: resolve => require(['views/propmotion-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '促销管理/促销活动详情' }
  },
  {
    path: '/goods-manage/goods-detail/:id',
    props: true,
    name: 'goods-detail',
    component: resolve => require(['views/goods-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '商品管理/商品详情' }
  },
  {
    path: '/banner-manage',
    name: 'banner-manage',
    component: resolve => require(['views/banner-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/banner-manage/banner-detail/:position/:id',
    name: 'banner-detail',
    props: true,
    component: resolve => require(['views/banner-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '广告位管理/广告位详情' }
  },
  {
    path: '/active-setting',
    name: 'active-setting',
    component: resolve => require(['views/active-setting'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/label-manage',
    name: 'label-manage',
    component: resolve => require(['views/label-manage'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/label-manage/related-label',
    name: 'related-label',
    component: resolve => require(['views/related-label'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '标签管理/标签关联表' }
  },
  {
    path: '/third-vendors',
    name: 'third-vendors',
    component: resolve => require(['views/third-vendors'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/third-vendors/third-vendor-form/:isEdit/:id',
    name: 'third-vendor-form',
    props: true,
    component: resolve => require(['views/third-vendor-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '第三方供应商/第三方供应商', isForm: true }
  },
  {
    path: '/third-vendors-detail/:id',
    name: 'third-vendors-detail',
    props: true,
    component: resolve => require(['views/third-vendors-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '第三方供应商/第三方供应商详情' }
  },
  {
    path: '/old-to-new',
    name: 'old-to-new',
    component: resolve => require(['views/old-to-new'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/old-to-new/old-to-new-detail/:id/:type',
    props: true,
    name: 'old-to-new-detail',
    component: resolve => require(['views/old-to-new-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '脐荐康管理/脐荐康详情' }
  },
  {
    path: '/old-to-new/batch-grant',
    props: true,
    name: 'batch-grant',
    component: resolve => require(['views/batch-grant'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '脐荐康管理/批量发放' }
  },
  {
    path: '/goods-qr-code',
    name: 'goods-qr-code',
    component: resolve => require(['views/goods-qr-code'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/qr-code-form/:isEdit/:id',
    props: true,
    name: 'qr-code-form',
    component: resolve => require(['views/qr-code-form'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '商品二维码/新建二维码' }
  },
  {
    path: '/goods-qr-code-detail/:id',
    props: true,
    name: 'goods-qr-code-detail',
    component: resolve => require(['views/goods-qr-code-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '商品二维码/二维码详情' }
  },
  {
    path: '/export-history/old_to_new',
    props: true,
    name: 'export-history-new',
    component: resolve => require(['views/export-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '脐荐康管理/脐荐康记录导出历史' }
  }
]
